import { render, staticRenderFns } from "./MemberCop.vue?vue&type=template&id=3ee844f8"
import script from "./MemberCop.vue?vue&type=script&lang=js"
export * from "./MemberCop.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports